export const SITE_DETAILS_CARD_FRENCH_LOCALE = {
  title: "Site",
  phoningMission: "Mission",
  siteId: "Site Id",
  externalId: "Id externe",
  companyName: "Nom de l'entreprise",
  address: "Adresse",
  subscribedPower: "Puissance souscrite",
  layoutType: "Type de site",
  layout: "Sous-type de site",
  surface: "Surface",
};
